export enum RequestContentType {
    JSON = "application/json",
    FORM = "multipart/form-data",
}
